let scrollPosition = 0;

function addScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.classList.add('scroll-lock');
    document.body.style.top = `-${scrollPosition}px`;
}

function removeScrollLock() {
    document.body.classList.remove('scroll-lock');
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
}

const sideMenu = document.querySelectorAll('.side-menu');

sideMenu.forEach(menu => {
  const sideMenuOpenBtn = menu.previousElementSibling;

  sideMenuOpenBtn.addEventListener('click', () => {
    addScrollLock();

    if (sideMenuOpenBtn.hasAttribute('data-account-btn')) {
      menu.dataset.accountMenu = 'show';
    }

    if (sideMenuOpenBtn.hasAttribute('data-menu-btn')) {
      menu.dataset.mainMenu = 'show';
    }
  });

  const sideMenuCloseBtn = menu.querySelector('.side-menu__close');

  sideMenuCloseBtn.addEventListener('click', () => {
    removeScrollLock();

    if (menu.dataset.accountMenu === 'show') {
      menu.dataset.accountMenu = 'hide';
    }

    if (menu.dataset.mainMenu === 'show') {
      menu.dataset.mainMenu = 'hide';
    }
  });
});

const productsOpenMenuBtn = document.querySelectorAll('button.side-menu__nav-link');

const showHideLevelMenu = (menu) => {
    if (menu.getAttribute('data-level-menu') === '') {
        menu.style.display = 'block';
        setTimeout(() => {
            menu.setAttribute('data-level-menu', 'show');
        }, 100);
    } else {
        menu.setAttribute('data-level-menu', '');
        setTimeout(() => {
            menu.removeAttribute('style');
        }, 200);
    }
}

productsOpenMenuBtn.forEach((btn) => {
    const levelMenu = btn.nextElementSibling;
    if (levelMenu) {
        const backMenuBtn = levelMenu.querySelector('.side-menu__back-btn');

        btn.addEventListener('click', () => {
            showHideLevelMenu(levelMenu);
        });
        backMenuBtn.addEventListener('click', () => {
            showHideLevelMenu(levelMenu);
        });
    }
});
